module.exports = __webpack_public_path__ + "img/red-square-table-12.52963389.png";